module.exports = __webpack_public_path__ + "static/media/dashboard_map.bd2e1dc7.png";